import { faClipboard, faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider, IconButton, ListItem, ListItemSecondaryAction, ListItemText, ListSubheader, makeStyles } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import ReactJson from 'react-json-view';
import { useCopyToClipboard } from 'usehooks-ts';

const useStyles = makeStyles(theme => ({
  actions: {
    display: 'flex',
    flexDirection: 'column',
  }
}));
const TestSelectGenerator = ({ catId, service }) => {
  const classes = useStyles()
  const [value, copy] = useCopyToClipboard()
  const getServiceLink = useCallback(
    (pkg) => {
      const prefix = process.env.NODE_ENV === 'development' ? `${window.location.protocol}//${window.location.host}/createbooking?` : `${process.env.REACT_APP_SELF_LINK}/createbooking?`
      const serviceObject = {
        'item': pkg?.featured_content?.name
      }
      const searchparams = new URLSearchParams(
        serviceObject
      ).toString()

      return `${prefix}${searchparams}`
    },
    [],
  );
  return (
    <>
      <ListSubheader disableSticky>{service?.type?.label}</ListSubheader>
      {service?.extended_packages?.map(service => {
        const link = getServiceLink(service)
        return (
          <>
            <ListItem>
              <ListItemText primary={`${service.label}`}
                secondary={link}
              />
              <ListItemSecondaryAction className={classes.actions}>
                {/* <IconButton size="small" onClick={() => {
                  copy(link)
                  toast.success('Copied to clipboard')
                }}>
                  <FontAwesomeIcon icon={faClipboard} />
                </IconButton> */}
                <IconButton size="small" onClick={() => window.open(link, '_blank')}>
                  <FontAwesomeIcon icon={faLink} />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </>
        )
      })}
    </>
  )
}

export { TestSelectGenerator }